import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { MarketingArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends MarketingArea>(name: Extract<keyof T, string>): string { return name; };

export const marketingMenu: MenuMainNode = {
    icon: 'marketingIconTemplate',
    title: 'Menu.Marketing.Name',  
    rootPath: '/marketing',  
    areaPermissionKey: permissionAreaKeyNameOf('marketing'),
    children: [
        {
            title: 'Menu.Marketing.ReferralSources.Name',
            abbreviation: 'Menu.Marketing.ReferralSources.Abbreviation',
            link: '/marketing/referral-sources',
            entityPermissionKey: entityKeyResolver("referralSources")
        },
        {
            title: 'Menu.Marketing.MarketingCampaigns.Name',
            abbreviation: 'Menu.Marketing.MarketingCampaigns.Abbreviation',
            link: '/marketing/marketing-campaigns',
            entityPermissionKey: entityKeyResolver("marketingCampaigns")
        }    
    ]
};
